import { render } from "./EditMsPunsMessageForm.vue?vue&type=template&id=5383a80d"
import script from "./EditMsPunsMessageForm.vue?vue&type=script&lang=js"
export * from "./EditMsPunsMessageForm.vue?vue&type=script&lang=js"

import "./EditMsPunsMessageForm.vue?vue&type=style&index=0&id=5383a80d&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5383a80d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5383a80d', script)) {
    api.reload('5383a80d', script)
  }
  
  module.hot.accept("./EditMsPunsMessageForm.vue?vue&type=template&id=5383a80d", () => {
    api.rerender('5383a80d', render)
  })

}

script.__file = "src/components/ms-puns-message/EditMsPunsMessageForm.vue"

export default script